import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forEach, findIndex } from 'lodash';

import { NotificationsService } from '../../../services/notifications.service';
import { SocketResponse, SocketService } from '../../../services/socket.service';
import { NotificationsListService } from './notifications-list.service';
import { ConfirmModalComponent } from '../../../shared/modals/confirm-modal/confirm-modal.component';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss'],
  standalone: false,
})
export class NotificationsListComponent implements OnInit {
  public notificationsBreadcrumbs = [{ text: 'Уведомления', url: null }];
  public notificationsData = null;
  public unionLoading = false;
  public partialLoading = false;
  public filter = {
    notificationsStatues: null,
    params: {
      status: '',
      priority: '',
      notification_type: '',
      offset: 0,
      limit: 25,
    },
    paginationBlock: {
      limits: [25, 50, 100],
      limitSelected: 25,
      countsAllElements: null,
    },
    notificationsShowTypeSelected: 'all',
    notificationStatusSelected: null,
    onApplyFilter: () => {
      this.filter.params.offset = 0;
      this.getNotifications(false);
    },
    onResetFilter: () => {
      this.filter.params.offset = 0;
      this.onResetFilter();
    },
    onUpdateWidget: () => {
      this.onResetData();
    },
    onChangeNotificationsStatuses: (status) => {
      this.onChangeNotificationsStatuses(status);
    },
    onChangeNotificationsFilterType: (type) => {
      this.filter.params.offset = 0;
      this.onChangeNotificationsFilterType(type);
    },
    onChangeLimitPaginationBlock: (limit) => {
      this.filter.paginationBlock.limitSelected = limit;
      this.filter.params.limit = limit;
    },
    onGetPartialData: () => {
      this.filter.params.offset += this.filter.paginationBlock.limitSelected;
      this.getNotifications(true);
    },
  };

  constructor(
    private notificationsService: NotificationsService,
    private socketService: SocketService,
    private notificationsListService: NotificationsListService,
    public modalService: NgbModal,
    private breadcrumbsService: BreadcrumbsService
  ) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.notificationsBreadcrumbs);

    this.socketService.subscribe('notification_push', (socketData: SocketResponse) => {
      this.checkNotificationStatus(socketData);
    });

    this.getNotificationsUnion(false);
  }

  public getNotificationsUnion(isPartial: boolean): void {
    this.unionLoading = true;
    this.notificationsService.getNotificationsUnion(this.filter.params).subscribe(
      (response) => {
        this.notificationsData = response[0]['data'].results;
        this.filter.paginationBlock.countsAllElements = response[0]['data'].count;
        this.filter.notificationsStatues = response[1]['data'];
        this.notificationsListService.updateNotifications(this.notificationsData);
        this.unionLoading = false;
      },
      (error) => {
        this.notificationsData = null;
        this.filter.notificationsStatues = null;
        this.unionLoading = false;
      }
    );
  }

  public getNotifications(isPartial: boolean): void {
    this.partialLoading = true;
    this.notificationsService.getAllNotifications(this.filter.params).subscribe(
      (response) => {
        if (isPartial) {
          this.notificationsData = this.notificationsData.concat(response['data'].results);
        } else {
          this.notificationsData = response['data'].results;
        }

        this.filter.paginationBlock.countsAllElements = response['data'].count;
        this.notificationsListService.updateNotifications(this.notificationsData);
        this.partialLoading = false;
      },
      (error) => {
        this.notificationsData = null;
        this.partialLoading = false;
      }
    );
  }

  public checkNotificationStatus(socketData: SocketResponse): void {
    let notification = socketData.data;
    let notificationIndex = findIndex(this.notificationsData, {
      id: notification.id,
    });

    if (notificationIndex > -1) {
      this.notificationsData[notificationIndex] = notification;
    }
  }

  public onResetFilter(): void {
    this.filter.notificationStatusSelected = null;
    this.filter.params.notification_type = '';
    this.getNotifications(false);
  }

  public onResetData(): void {
    this.filter.params = {
      status: '',
      priority: '',
      notification_type: '',
      offset: 0,
      limit: this.filter.paginationBlock.limitSelected,
    };
    this.getNotifications(false);
  }

  public onChangeNotificationsStatuses(status: string): void {
    if (status === 'check') {
      const confirmCloseStepsComponent = this.modalService.open(ConfirmModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-wrapper',
        backdrop: 'static',
      });

      confirmCloseStepsComponent.componentInstance.title = 'Пометить все прочитанным';
      confirmCloseStepsComponent.componentInstance.description = 'Вы действительно хотите пометить все' + ' непрочитанные уведомления прочитанными?';
      confirmCloseStepsComponent.componentInstance.successButtonName = 'Да, пометить';
      confirmCloseStepsComponent.componentInstance.abortButtonName = 'Отмена';

      confirmCloseStepsComponent.result.then(
        () => {
          this.statusesChange();
        },
        () => {}
      );
    } else {
      this.statusesChange();
    }
  }

  public statusesChange(): void {
    this.partialLoading = true;
    this.notificationsService.changeNotificationsToReadStatus({}).subscribe(
      (response) => {
        this.getNotifications(false);
        this.partialLoading = false;
      },
      () => {
        this.partialLoading = false;
      }
    );
  }

  public onChangeNotificationsFilterType(type: string): void {
    this.filter.notificationsShowTypeSelected = type;

    if (type === 'all') {
      this.filter.params.status = '';
      this.filter.params.priority = '';
    } else if (type === 'priority') {
      this.filter.params.status = '';
      this.filter.params.priority = '1';
    } else if (type === 'status') {
      this.filter.params.priority = '';
      this.filter.params.status = '0';
    }

    this.getNotifications(false);
  }
}
